$(function () {
    var tour = $('#tour');
    var open_trigger = $('.open_tour_js');
    var close_trigger = $('.close_tour_js')
    var body = $(document.body);

    open_trigger.on('click', function (event) {
        event.preventDefault();
        body.css('overflow-y', 'hidden');
        tour.addClass('tour_open');
        tour.addClass('tour_visible');
        fast_background.update();
    });
    close_trigger.on('click', function () {
        tour.removeClass('tour_visible');
        setTimeout(function () {
            tour.removeClass('tour_open');
            body.css('overflow-y', 'auto');
        }, 400);
    });

    //При клике на категорию помещения, скроллим к изображениям этого помещения.
    $('[data-scroll-tour]').click( function(){
    	var scroll_el = $(this).attr('href');
    	if ($(scroll_el).length != 0) {
    	$('.tour_visible').animate({ scrollTop: $(scroll_el).offset().top }, 500);
    	}
    	return false;
    });
})
